export default __webpack_public_path__ + "static/media/ref3.9cdcc4c1.mp3";